// GetNoOfAdvisers.js
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../backend/firebaseConfig";

/**
 * Fetches the total number of advisers from Firestore,
 * counting all except those explicitly marked `isAppointed === false`.
 *
 * The final count is forced down to the *next lower multiple of 5*,
 * even if the number is already a multiple of 5.
 *
 * @async
 * @function fetchNoOfAdvisers
 * @returns {Promise<number>} Rounded-down adviser count
 */
export const fetchNoOfAdvisers = async () => {
  // console.log("[fetchNoOfAdvisers] Starting adviser count from Firestore…");

  try {
    const advisersRef = collection(
      db,
      "Authorized Members",
      "Advisers",
      "Data"
    );
    // console.log(
    //   "[fetchNoOfAdvisers] Fetching advisers from:",
    //   advisersRef.path
    // );

    const snapshot = await getDocs(advisersRef);
    // console.log(
    //   `[fetchNoOfAdvisers] Total adviser documents fetched: ${snapshot.size}`
    // );

    let count = 0; //Callums details are missing, so starting from 0

    snapshot.forEach((docSnap) => {
      const data = docSnap.data() || {};
      const appointed = data?.isAppointed;

      // Count if true OR missing/undefined
      if (appointed !== false) {
        count++;
      }
    });

    // Always round down below the nearest multiple of 5
    const roundedCount = Math.floor((count - 1) / 5) * 5;

    // console.log(
    //   `[fetchNoOfAdvisers] Final adviser count (excluding isAppointed=false): ${count} → Rounded down to: ${roundedCount}`
    // );

    return roundedCount;
  } catch (error) {
    // console.error(
    //   "[fetchNoOfAdvisers] Error fetching adviser count:",
    //   error
    // );
    return 160;
  }
};
